export default __webpack_public_path__ + "static/media/Ps.0f3063c7.svg";